import { css } from 'styled-components/macro';
import { colorBlackTransparent300, colorBlackTransparent50 } from '@yme/tokens/colors';
export const CustomScroll = css `
  ${({ isHorizontal }) => !isHorizontal && 'border: 6px solid transparent;'}
  ${({ isHorizontal }) => (isHorizontal ? 'overflow-x: auto;' : 'overflow-y: auto;')}
  ${({ isHorizontal }) => !isHorizontal && 'max-height: 212px;'}
 
  ${({ isRightToLeft, isHorizontal }) => {
    if (!isHorizontal) {
        return isRightToLeft ? 'padding-left: 8px;' : 'padding-right: 8px;';
    }
    return '';
}}


  /* Scroll bar width */
  ::-webkit-scrollbar {
    ${({ isHorizontal }) => (isHorizontal ? 'height: 6px;' : 'width: 6px;')}

    background-color: ${colorBlackTransparent50};

    border-radius: 3px;
  }

  /* Color of the scroll bar thumb */
  &::-webkit-scrollbar-thumb {
    background-color: ${colorBlackTransparent300};
    border-radius: 3px;
  }

  /* Color of the scroll bar thumb when hovering */
  ::-webkit-scrollbar-thumb:hover {
  }

  /* Background color of the scroll bar track */
  ::-webkit-scrollbar-track {
    background-color: ${colorBlackTransparent50};
    border-radius: 3px;
  }

  /* Color of the track when hovering over the scroll bar */
  ::-webkit-scrollbar-track:hover {
  }

  @supports not selector(::-webkit-scrollbar) {
    scrollbar-width: thin;
    scrollbar-color: ${colorBlackTransparent300} ${colorBlackTransparent50};
  }
`;
